module.exports = __webpack_public_path__ + "img/novelty-gps.e524f41b.png";